<template>
  <div class="step2-container">
    <div class="title">设置新密码</div>
    <div class="des">8-16位字符，包含大写字母、小写字母、数字和特殊符号</div>
    <div class="form">
			<el-input
				v-model="formData.password"
				placeholder="新密码"
				size="large"
				class="input-item"
				type="password"
				show-password
				clearable
				@blur="validatePass"
			/>
			<div class="error-tip">
				{{ formData.passwordMsg }}
			</div>
		
			<el-input
				v-model="formData.confimPassword"
				placeholder="确认密码"
				size="large"
				class="input-item"
				type="password"
				show-password
				clearable
				@blur="validateConfirmPass"
			/>
			<div class="error-tip">
				{{ formData.confimPasswordMsg }}
			</div>

			<el-button type="primary"  size="large" style="width: 400px;margin-top:8px" @click="onSubmit">
				提交
			</el-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive } from 'vue'
import { catchError } from '@/utils'
import { ElMessage } from 'element-plus'
import { retrievePassword } from '@/api/retrieve'

const props = defineProps<{
  authKey: string,
	next: () => void
}>()


const formData = reactive({
  password: '',
	passwordMsg: '',
  confimPassword: '',
	confimPasswordMsg: ''
})

const validatePass = () => {
  const reg = /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,16}$/;
  if (formData.password === '') {
    formData.passwordMsg = '新密码不能为空';
  } else if (!reg.test(formData.password)) {
		formData.passwordMsg = '密码必须包含大、小写字母、数字和特殊符号，且在8-16之间';
  } else {
  	formData.passwordMsg = '';
	}
}

const validateConfirmPass = () => {
  if (formData.confimPassword === '') {
    formData.confimPasswordMsg = '确认密码不能为空'
  } else if(formData.confimPassword !== formData.password){
    formData.confimPasswordMsg = '请保持两次密码一致'
  } else {
		formData.confimPasswordMsg = ''
	}
}

const onSubmit = async () => {
	validatePass();
	validateConfirmPass();

	if(formData.passwordMsg || formData.confimPasswordMsg) {
		return;
	}

  const { response, error } = await catchError(
    retrievePassword(
      {
        authKey: props.authKey,
        newPassword: formData.password,
      }
    )
  )

  if (error) {
    return;
  } 
	
	if (response?.code) {
    ElMessage.warning(response!.message)
    return
  }

	props.next();
}

</script>
<style lang="scss" scoped>
.step2-container {
  text-align: center;
  .title {
    font-size: 24px;
    font-weight: 600;
  }

  .des {
    font-size: 14px;
    color: #999;
    margin-top: 15px;
  }

  .form {
		display: flex;
		flex-direction: column;
    padding-top: 30px;
		position: relative;

		& > * {
			width: 400px;
			height: 32px;
			--el-input-height: 30px;
			place-self: center;
		}

		
		.error-tip {
			position: relative;
			font-size: 12px;
			color: red;
			line-height: 28px;
			text-align: left;
			margin-top: -4px;
		}

    // .form-inline {
    //   @media screen and (orientation: portrait) {
    //     width: 300px;
    //   }
    //   .input-item {
    //     width: 400px;
    //   }
    // }
		}
}
</style>
